import { useQuery } from '@tanstack/react-query'

import { axiosInstance } from '../../../../helpers'
import { marketingChannelsKey } from '../../hooks/leasingSeasonKeys'
import { MarketingChannelsResponse } from '../types'

export function useMarketingChannels(seasonId: number | null | undefined) {
    return useQuery({
        queryKey: marketingChannelsKey(seasonId),
        queryFn: async () => {
            const { data } = await axiosInstance.get<MarketingChannelsResponse>(
                `/outreach/leasing-seasons/${seasonId}/marketing-channels/`,
            )
            return data
        },
        enabled: seasonId != null,
        staleTime: 30_000,
        refetchOnWindowFocus: true,
    })
}
